import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import i18n from './i18n';

const dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
//for the diraction of input placeholder
const cacheRtl = createCache({
  key: dir === 'rtl' ? 'mui-rtl' : 'mui',
  stylisPlugins: dir === 'rtl' ? [rtlPlugin] : [],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CacheProvider value={cacheRtl}>
      <App />
  </CacheProvider>
);
